import { HandThumbUpIcon } from "@heroicons/react/24/outline";
import { CheckIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick/lib/slider";
import { getUser } from "../../Localstorage/localstorage";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const RPStepperWithPage = ({ vragenlijsten,datas, userdetails ,navigation}) => {
    // Determine the initial slide index
  const id = datas.find((item) => item.status === "current")?.id;
  const [slideIndex, setSlideIndex] = useState(0);
  const [updateCount, setUpdateCount] = useState(0); 
  const user = getUser();
  
useEffect(() => {
  if(id !== undefined)
  setSlideIndex(id)

}, [id]);


  

  return (
    <section className="flex min-h-0 flex-1 flex-col bg-wa-app text-wa-text">
      <div className="shrink-0 border-wa-border/80 bg-wa-app pt-4 lg:border-b lg:border-t lg:pt-0">
        <nav
          className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
          aria-label="Progress"
        >
          <ol
            role="list"
            className="overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_18px_48px_-28px_rgba(0,0,0,0.42)] ring-1 ring-black/5 dark:shadow-[0_22px_55px_-24px_rgba(0,0,0,0.55)] dark:ring-white/5 lg:flex lg:rounded-none lg:border-x lg:border-y-0 lg:shadow-none lg:ring-0"
          >
            {datas.map((step, stepIdx) => (
              <li
                key={step.id}
                {...(step.status !== "upcoming"
                  ? { onClick: () => setSlideIndex(stepIdx) }
                  : {})}
                className={classNames(
                  "relative overflow-hidden transition-colors duration-200 lg:flex-1",
                  stepIdx === slideIndex
                    ? "bg-wa-panel2/95 ring-1 ring-inset ring-wa-accent/25"
                    : "bg-wa-panel",
                  step.status !== "upcoming" && "cursor-pointer hover:bg-wa-hover/80"
                )}
              >
                <div
                  className={classNames(
                    stepIdx === 0 ? "rounded-t-md border-b-0" : "",
                    stepIdx === datas.length - 1
                      ? "rounded-b-md border-t-0"
                      : "",
                    "overflow-hidden border border-wa-border lg:border-0"
                  )}
                >
                  {step.status === "complete" ? (
                    <a href={step.href} className="group block">
                      <span
                        className="absolute left-0 top-0 h-full w-1 bg-transparent group-hover:bg-wa-hover lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                        aria-hidden="true"
                      />
                      <span
                        className={classNames(
                          stepIdx !== 0 ? "lg:pl-9" : "",
                          "flex items-start px-6 py-5 text-sm font-medium"
                        )}
                      >
                        <span className="flex-shrink-0">
                          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-wa-accent shadow-md ring-1 ring-black/10 dark:ring-white/10">
                            <CheckIcon
                              className="h-6 w-6 text-wa-onaccent"
                              aria-hidden="true"
                            />
                          </span>
                        </span>
                        <span className="mx-4 mt-0.5 flex min-w-0 flex-col">
                          <span className="text-sm font-medium text-wa-text">
                            {step.name}
                          </span>
                          <span className="text-xs text-wa-muted">
                            {step.description}
                          </span>
                        </span>
                      </span>
                    </a>
                  ) : step.status === "current" ? (
                    <a href={step.href} aria-current="step" className="block">
                      <span
                        className="absolute left-0 top-0 h-full w-1 bg-wa-accent lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                        aria-hidden="true"
                      />
                      <span
                        className={classNames(
                          stepIdx !== 0 ? "lg:pl-9" : "",
                          "flex items-start px-6 py-5 text-sm font-medium"
                        )}
                      >
                        <span className="flex-shrink-0">
                          <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-wa-accent bg-wa-panel2 shadow-md ring-1 ring-wa-accent/20">
                            <span className="text-sm font-semibold text-wa-accent">
                              {step.id + 1}
                            </span>
                          </span>
                        </span>
                        <span className="ml-4 mt-0.5 flex min-w-0 flex-col">
                          <span className="text-sm font-semibold text-wa-accent">
                            {step.name}
                          </span>
                          <span className="text-xs font-medium text-wa-muted">
                            {step.description}
                          </span>
                        </span>
                      </span>
                    </a>
                  ) : step.status === "upcoming" ? (
                    <div className="group">
                      <span
                        className="absolute left-0 top-0 h-full w-1 bg-transparent group-hover:bg-wa-hover lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                        aria-hidden="true"
                      />
                      <span
                        className={classNames(
                          stepIdx !== 0 ? "lg:pl-9" : "",
                          "flex items-start px-6 py-5 text-sm font-medium"
                        )}
                      >
                        <span className="flex-shrink-0">
                          <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-dashed border-wa-border bg-wa-panel2/40 opacity-90">
                            <span className="text-sm font-medium text-wa-muted">
                              {step.id + 1}
                            </span>
                          </span>
                        </span>
                        <span className="ml-4 mt-0.5 flex min-w-0 flex-col">
                          <span className="text-sm font-medium text-wa-muted">
                            {step.name}
                          </span>
                          <span className="text-xs font-medium text-wa-muted/90">
                            {step.description}
                          </span>
                        </span>
                      </span>
                    </div>
                  ) : (
                    <div className="group">
                      <span
                        className="absolute left-0 top-0 h-full w-1 bg-transparent group-hover:bg-wa-hover lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                        aria-hidden="true"
                      />
                      <span
                        className={classNames(
                          stepIdx !== 0 ? "lg:pl-9" : "",
                          "flex items-start px-6 py-5 text-sm font-medium"
                        )}
                      >
                        <span className="flex-shrink-0">
                          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-wa-border bg-wa-hover text-wa-accent shadow-sm">
                            <HandThumbUpIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          </span>
                        </span>
                        <span className="mx-4 mt-0.5 flex min-w-0 flex-col">
                          <span className="text-sm font-medium text-wa-text">
                            {step.name}
                          </span>
                          <span className="text-xs text-wa-muted">
                            {step.description}
                          </span>
                        </span>
                      </span>
                    </div>
                  )}

                  {stepIdx !== 0 ? (
                    <>
                      {/* Separator */}
                      <div
                        className="absolute inset-0 left-0 top-0 hidden w-4 lg:block"
                        aria-hidden="true"
                      >
                        <svg
                          className={classNames(
                            "h-full w-full",
                            stepIdx === slideIndex || stepIdx === slideIndex + 1
                              ? "text-wa-accent"
                              : "text-wa-border"
                          )}
                          viewBox="0 0 12 82"
                          fill="none"
                          preserveAspectRatio="none"
                        >
                          <path
                            d="M0.5 0V31L10.5 41L0.5 51V82"
                            stroke="currentcolor"
                            vectorEffect="non-scaling-stroke"
                          />
                        </svg>
                      </div>
                    </>
                  ) : null}
                </div>
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <div className="slider-container min-h-0 flex-1 overflow-y-auto bg-wa-app pb-10">
          {datas.map((step, stepIdx) => (
            <div key={stepIdx} className="mx-auto max-w-7xl px-4 py-5 sm:px-6 lg:px-8">
              {slideIndex === stepIdx ? (
                <div className="rounded-2xl border border-wa-border/90 bg-wa-panel2/25 shadow-[0_16px_44px_-32px_rgba(0,0,0,0.5)] ring-1 ring-black/[0.04] dark:bg-wa-panel/25 dark:ring-white/[0.06]">
                  <div className="rounded-2xl p-1 sm:p-2">
                    <step.component
                      userdetails={userdetails}
                      user={user}
                      navigation={navigation}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          ))}
      </div>
    </section>
  );
};

export default RPStepperWithPage;
